import React, { useEffect, useState } from "react";
import "./ImageSlidePopup.css"; // Import CSS for styling
// import LendingPartnerLogo from "../../../../assets/Images/Dashboard/lending-partner-logo.png";
import LendingPartnerLogo from "../../../assets/Images/Dashboard/lending-partner-logo.png";

const ImageSliderpopup = (props) => {
  const images = props?.imageArr;

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentIndex((prevIndex) =>
        prevIndex === images.length - 1 ? 0 : prevIndex + 1
      );
    }, 4000);

    return () => clearInterval(slideInterval); // Cleanup interval on component unmount
  }, []);

  return (
    <>
            <div class="imagepopup-slider-overlaping-text"><h1 class="first-line-heading">Get Your Own</h1><h1 class="second-line-heading">Secured Dashboard</h1></div>
            <div className="image-popup-slider-container">
      {/* <button className="nav-btn prev-btn" onClick={handlePrev}>
        &#10094;
      </button> */}

      <div className="image-popup-slider">
        {images.map((image, index) => {
          const isActive = index === currentIndex;
          const isLeft = index === (currentIndex - 1 + images.length) % images.length;
          const isRight = index === (currentIndex + 1) % images.length;

          return (
            <div
              key={index}
              className={`image-popup-slide slide ${
                isActive ? "active" : isLeft ? "left" : isRight ? "right" : "hidden"
              }`}
              onClick={(e)=>{isLeft ? handlePrev () : isRight? handleNext() : e.stopPropagation()}}
            >
              <img src={image} alt={`Slide ${index + 1}`} />
              <p className="image-description">A space tailored to you, ensuring your loan details are protected</p>
            </div>
          );
        })}
      </div>
      {/* <button className="nav-btn next-btn" onClick={handleNext}>
        &#10095;
      </button> */}
      <div className="imagepopup-navigator-bar">
          <div onClick={()=>setCurrentIndex(0)} className={`${currentIndex ===0 ? 'active' :''} first-imageslider imagepopup-navigator`}>
              <div className="circal-info"></div>
              <p className="navi-heading">Personalized & Secure</p>
          </div>
          <div onClick={()=>setCurrentIndex(1)}  className={`${currentIndex ===1 ? 'active' :''} first-imageslider imagepopup-navigator`}>
              <div className="circal-info"></div>
              <p className="navi-heading">Real-Time Tracking</p>
          </div>
          <div onClick={()=>setCurrentIndex(2)}  className={`${currentIndex ===2 ? 'active' :''} first-imageslider imagepopup-navigator`}>
              <div className="circal-info"></div>
              <p className="navi-heading">Easy Access to Schedules</p>
          </div>
      </div>
    </div>
    </>

  );
};

export default ImageSliderpopup;
